const RASTER = /\.(jpe?g|png|webp)$/i;

export function responsive(src: string) {
  if (!RASTER.test(src)) return { src, srcSet: undefined };

  const base = src.replace(RASTER, "");
  return {
    src: `${base}-1600.webp`,
    srcSet: `${base}-800.webp 800w, ${base}-1600.webp 1600w`,
  };
}
